module.exports = __webpack_public_path__ + "img/chrome7.6953a53c.png";